// Maps a cow-diagram region (the SVG group id, normalized) to one or more
// primal_cut terms. Most regions map 1:1; the `loin` region covers both the
// Loin and Sirloin primals and is shown as "Sirloin".
export const REGION_PRIMALS = {
  loin: { label: 'Loin', slugs: ['loin', 'sirloin'] }
};

// Resolve a region slug to its matched primals (from the loaded primalCuts) and
// a display label.
export function resolveRegion(regionSlug, primalCuts) {
  const config = REGION_PRIMALS[regionSlug] || { label: null, slugs: [regionSlug] };
  const matched = primalCuts.filter((primal) =>
    config.slugs.includes(primal.name.toLowerCase())
  );
  const label = config.label || (matched[0] ? matched[0].name : null);
  return { matched, label, slugs: config.slugs };
}

// Given the currently selected primals, return the heading label — using a
// region alias label when the selection exactly matches an alias group.
export function labelForSelection(selectedPrimals) {
  if (!selectedPrimals.length) return null;

  const names = selectedPrimals.map((primal) => primal.name.toLowerCase()).sort();

  const aliasMatch = Object.values(REGION_PRIMALS).find((region) => {
    const slugs = [...region.slugs].sort();
    return (
      slugs.length === names.length && slugs.every((slug, i) => slug === names[i])
    );
  });

  return aliasMatch ? aliasMatch.label : selectedPrimals[0].name;
}
